export const FETCH_STUDENT_SSD_ACCOMMODATIONS_PENDING   = 'FETCH_STUDENT_SSD_ACCOMMODATIONS_PENDING'
export const FETCH_STUDENT_SSD_ACCOMMODATIONS_FULFILLED = 'FETCH_STUDENT_SSD_ACCOMMODATIONS_FULFILLED'
export const FETCH_STUDENT_SSD_ACCOMMODATIONS_REJECTED  = 'FETCH_STUDENT_SSD_ACCOMMODATIONS_REJECTED '
